import { Component, Input } from '@angular/core';
import { DsButtonVariants, Icons } from '@levelaccess/design-system';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ds-action-confirmation-modal',
  templateUrl: './ds-action-confirmation-modal.component.html',
  styleUrls: ['./ds-action-confirmation-modal.component.scss'],
  standalone: false,
})
export class DsActionConfirmationModalComponent {
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  public readonly Icons: typeof Icons = Icons;

  @Input() public title: string;
  @Input() public message: string;
  @Input() public confirmLabel: string;
  @Input() public cancelLabel: string;
  @Input() public closeLabel: string;
  @Input() public maxWidthPercentage: number = 45;
  @Input() public closeAllModals: boolean = false;

  constructor(public modal: NgbActiveModal) {}

  public onCancel(): void {
    this.modal.dismiss();
  }

  public onConfirm(): void {
    this.modal.close();
  }
}
